import { ref, unref } from 'vue'
import { ElLoading as Loading } from 'element-plus'
// import type { ElLoading, LoadingOptionsResolved } from 'element-plus'

export function useLoading() {
  const instance = ref<any>(null as any)
  function openFull(options: any = null) {
    instance.value = Loading.service(
      Object.assign(
        {
          body: true,
          fullscreen: true,
          text: '加载中'
        },
        { ...options }
      )
    )
  }
  function close() {
    unref(instance)?.close()
  }
  return {
    openFull,
    close
  }
}
